"use client"

import * as React from "react"
import { ReactNode } from "react"
import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import { SheetHeader } from "@ui/shad"

import { Sheet, SheetContent, SheetDescription, SheetTitle } from "./shad/sheet"

interface SlideoverProps {
  open: boolean
  title?: ReactNode
  description?: string
  onOpenChange: (open: boolean) => void
  children?: React.ReactNode
  size?: "half" | "sm" | "md" | "lg" | "xl" | "2xl" | "base"
  rightHeaderContent?: ReactNode
  onBack?: () => void
}

export function Slideover({
  open,
  title,
  onOpenChange,
  children,
  size = "base",
  rightHeaderContent,
  onBack,
}: SlideoverProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} modal>
      <SheetContent
        size={size}
        onInteractOutside={(ev) => {
          const target = ev.target as Element
          // Prevent sheet from closing when clicking DevTools
          if (target.closest(".tsqd-parent-container")) {
            ev.preventDefault()
            return
          }
          // Prevent sheet from closing when clicking voice transcription pill
          if (target.closest("[data-voice-transcription-pill]")) {
            ev.preventDefault()
          }
        }}
      >
        <SheetHeader onBack={onBack} headerTitle={title}>
          <div>
            <VisuallyHidden>
              <SheetTitle>Dialog</SheetTitle>
              <SheetDescription>Side panel dialog</SheetDescription>
            </VisuallyHidden>
          </div>
          {rightHeaderContent && <div className="flex items-center gap-2">{rightHeaderContent}</div>}
        </SheetHeader>
        <div className="relative">{children}</div>
      </SheetContent>
    </Sheet>
  )
}
